import { apiDaInscricao } from "../../../servicos/axios";

export type LocalAtendimentoDetalhe = {
  id: number;
  descricao: string;
  cidadeComUf: string;
  tipo: string;
  possuiPeriodoIndeterminado: boolean;
  dataDeVigenciaInicial?: string;
  dataDeVigenciaFinal?: string;
};

export const buscarLocalPorId = async (
  id: number
): Promise<LocalAtendimentoDetalhe> => {
  const response = await apiDaInscricao().get(
    `/LocalDeAtendimento/${id}/local`
  );
  return response.data;
};
